import ErrorComponent from "@/components/atoms/ErrorComponent";
import CompanyCourseHeader from "@/components/molecules/card-headers/companies/CompanyCourseHeader";
import CompanyCourseEditCard from "@/components/molecules/cards/companies/CompanyCourseEditCard";
import { UUID_REGEX } from "@/constants/regexs";
import { FC } from "react";
import { useParams } from "react-router-dom";

const CompanyCourseEditView: FC = () => {
  const { id, courseId } = useParams<{ id: string; courseId: string }>();

  if (!id || !UUID_REGEX.test(id) || !courseId || !UUID_REGEX.test(courseId)) {
    return (
      <ErrorComponent error={{ status: 404, data: {} }} absolute returnButton />
    );
  }
  return (
    <div className="formalys-page formalys-detail-page formalys-edit-page">
      <CompanyCourseHeader id={id} secondId={courseId} courseId={null} isEdit />
      <CompanyCourseEditCard id={id} secondId={courseId} />
    </div>
  );
};

export default CompanyCourseEditView;
